import React from 'react';
import { LayoutGrid, FolderKanban, User, Zap, Award, Briefcase } from 'lucide-react';

/**
 * Mobile Navigation Component
 * 
 * A fixed bottom navigation bar optimized for mobile devices.
 * Displays icons and labels for quick access to different sections.
 */
const MobileNav = ({ activeSection, setActiveSection }) => {
    const navItems = [
        { id: 'home', label: 'Home', icon: LayoutGrid },
        { id: 'experience', label: 'Exp', icon: Briefcase },
        { id: 'projects', label: 'Projects', icon: FolderKanban },
        { id: 'services', label: 'Services', icon: Zap },
        { id: 'certifications', label: 'Certs', icon: Award },
        { id: 'about', label: 'Profile', icon: User },
    ];

    return (
        <div className="md:hidden fixed bottom-0 left-0 right-0 z-50 bg-slate-900/90 backdrop-blur-xl border-t border-white/10 pb-safe">
            <div className="flex justify-around items-center px-2 py-3">
                {navItems.map((item) => {
                    const isActive = activeSection === item.id;
                    const Icon = item.icon;

                    return (
                        <button
                            key={item.id}
                            onClick={() => setActiveSection(item.id)}
                            className={`flex flex-col items-center gap-1 p-2 rounded-xl transition-all duration-300 ${isActive
                                ? 'text-purple-400 transform -translate-y-1'
                                : 'text-gray-500 hover:text-gray-300'
                                }`}
                        >
                            <div className={`p-1.5 rounded-full transition-all duration-300 ${isActive ? 'bg-purple-500/10' : 'bg-transparent'
                                }`}>
                                <Icon size={20} className={isActive ? 'stroke-[2.5px]' : 'stroke-2'} />
                            </div>
                            <span className={`text-[10px] font-medium transition-all ${isActive ? 'opacity-100' : 'opacity-60'
                                }`}>
                                {item.label}
                            </span>
                        </button>
                    );
                })}
            </div>
        </div>
    );
};

export default MobileNav;
